import { render, staticRenderFns } from "./OffBoardingForm.vue?vue&type=template&id=5a371f23&"
import script from "./OffBoardingForm.vue?vue&type=script&lang=js&"
export * from "./OffBoardingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports